<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="8" fill="#F3EFFA"/>
<rect x="12" y="5" width="16" height="30" rx="4" fill="url(#paint0_linear_1091_20216)"/>
<circle cx="20" cy="31" r="1.5" stroke="#F5EEFF"/>
<path d="M16 5H24V7C24 7.55228 23.5523 8 23 8H17C16.4477 8 16 7.55228 16 7V5Z" fill="#4300DA"/>
<path opacity="0.8" d="M28.3509 3C28.6075 2.55555 29.249 2.55556 29.5056 3L35.2791 13C35.5357 13.4444 35.2149 14 34.7017 14H23.1547C22.6415 14 22.3208 13.4444 22.5774 13L28.3509 3Z" fill="#F4E560"/>
<g style="mix-blend-mode:multiply">
<circle cx="10" cy="26" r="6" fill="#F07EFF"/>
</g>
<defs>
<linearGradient id="paint0_linear_1091_20216" x1="10.6857" y1="22.1875" x2="29.3932" y2="18.5036" gradientUnits="userSpaceOnUse">
<stop stop-color="#492EF3"/>
<stop offset="1" stop-color="#CF69FF"/>
</linearGradient>
</defs>
</svg>
